export const postInsight = (insight, cancelToken) => (
  (dispatch, getState, api) => api({
    method: 'post',
    apiPath: 'status/insight',
    data: { insight },
    cancelToken,
  })
)
